import { Helmet } from "react-helmet-async";
import { SITE_URL } from "../../utils/apiConfig";
import { useLanguage } from "../../context/LanguageProvider";

const SEO = ({
                 title,
                 description,
                 path = ""
             }) => {

    const { lang, dir } = useLanguage();

    return (
        <Helmet>

            <html lang={lang} dir={dir} />

            <title>{title}</title>

            <meta
                name="description"
                content={description}
            />

            <link
                rel="canonical"
                href={`${SITE_URL}/${lang}${path}`}
            />

            <link
                rel="alternate"
                hrefLang="fa"
                href={`${SITE_URL}/fa${path}`}
            />

            <link
                rel="alternate"
                hrefLang="en"
                href={`${SITE_URL}/en${path}`}
            />

            <link
                rel="alternate"
                hrefLang="x-default"
                href={`${SITE_URL}/fa${path}`}
            />

        </Helmet>
    );
};

export default SEO;